(function galleryButtons() {
    const carouselButtons = document.querySelectorAll("carousel-navigation .pill-nav-slider .pill-nav-item");

    carouselButtons.forEach(button => {
        if (button.classList.contains("js-prev")) {
            button.addEventListener("click", () => handleCarouselButtonClick("prev"));
        } else {
            button.addEventListener("click", () => handleCarouselButtonClick("next"));
        }
    });
})();

function handleCarouselButtonClick(action) {
    try {
        const thumbnails = Array.from(document.querySelectorAll(".product-media-thumbnails .product-media-thumbnail"));
        const activeThumbnailIndex = thumbnails.findIndex(thumbnail => thumbnail.classList.contains("is-active"));

        if (activeThumbnailIndex === -1) return;

        let newThumbnailIndex = activeThumbnailIndex;

        if (action === "prev") {
            newThumbnailIndex = activeThumbnailIndex - 1;
        } else {
            newThumbnailIndex = activeThumbnailIndex + 1;
        }

        if (newThumbnailIndex < 0 || newThumbnailIndex >= thumbnails.length) {
            return;
        }

        const toggle = thumbnails[newThumbnailIndex].querySelector(".product-media-toggle");

        if (toggle) {
            toggle.click();
        }
    } catch (error) {
        console.error("ERROR :: handleCarouselButtonClick", {error});
    }
}